import React from 'react';
import PropTypes from 'prop-types';

export const IconAward = ({ className }) => (
  <svg className={className} width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3327 10.6634V15.2444C11.3327 15.4285 11.1834 15.5778 10.9993 15.5778C10.9389 15.5778 10.8797 15.5614 10.8279 15.5303L7.99935 13.8332L5.17085 15.5303C5.01299 15.625 4.80824 15.5738 4.71352 15.416C4.68244 15.3641 4.66602 15.3048 4.66602 15.2444V10.6634C3.44673 9.68604 2.66602 8.1841 2.66602 6.49984C2.66602 3.55432 5.05383 1.1665 7.99935 1.1665C10.9449 1.1665 13.3327 3.55432 13.3327 6.49984C13.3327 8.1841 12.5519 9.68604 11.3327 10.6634ZM7.99935 10.4998C10.2085 10.4998 11.9993 8.70897 11.9993 6.49984C11.9993 4.2907 10.2085 2.49984 7.99935 2.49984C5.79021 2.49984 3.99935 4.2907 3.99935 6.49984C3.99935 8.70897 5.79021 10.4998 7.99935 10.4998ZM7.99935 9.1665C6.52659 9.1665 5.33268 7.97257 5.33268 6.49984C5.33268 5.02708 6.52659 3.83317 7.99935 3.83317C9.47208 3.83317 10.666 5.02708 10.666 6.49984C10.666 7.97257 9.47208 9.1665 7.99935 9.1665Z"
      fill="url(#icon-award-paint0_linear_14809_65165)"
    />
  </svg>
);

IconAward.propTypes = {
  className: PropTypes.string,
};

IconAward.defaultProps = {
  className: '',
};
